import { configureStore } from '@reduxjs/toolkit';
import productReducer from './features/products/productSlice';
import userReducer from './features/users/userSlice';
import chatReducer from './features/chat/chatSlice';
import bannerReducer from './features/banners/bannerSlice';
import wishlistReducer from './features/wishlist/wishlistSlice';
import orderReducer from './features/orders/orderSlice';

export const store = configureStore({
    reducer: {
        products: productReducer,
        user: userReducer,
        chat: chatReducer,
        banners: bannerReducer,
        wishlist: wishlistReducer,
        orders: orderReducer,
    },
});